import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      // A TINT OF THE FOREGROUND, NOT `bg-accent`. In light mode `--accent` is
      // L 0.976 on a pure-white card, so the pulse faded between two
      // near-whites and the skeleton read as a blank page — it was animating,
      // just invisibly. Foreground at 8% lands near the old dark-mode fill and
      // gives light mode a grey the pulse can visibly breathe on.
      className={cn('animate-pulse rounded-md bg-foreground/8', className)}
      {...props}
    />
  );
}

export { Skeleton };
